import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useEffect, useState } from "react"

export const useRemoveItemFromGroup = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [isError, setIsError] = useState(false)
	const { getAccessTokenSilently } = useAuth0()

	const removeItemFromGroup = useCallback(
		async (groupId, id, type) => {
			let path = ""
			let idName = ""

			switch (type) {
				case "devices":
					path = "devicegroup"
					idName = "device_id"
					break
				case "users":
					path = "usergroup"
					idName = "user_id"
					break
				default:
					throw new Error("Invalid type")
			}

			console.log(`Remove ${type} From Group: ` + id)

			setIsLoading(true)
			return fetch(
				new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/" + path, {
					method: "DELETE",
					headers: new Headers({
						"authorization": "Bearer " + (await getAccessTokenSilently()),
						"Content-Type": "application/json"
					}),
					body: JSON.stringify({ group_id: groupId, [idName]: id })
				})
			)
				.then((response) => {
					if (response.ok) {
						console.log(`Remove ${type} From Group successfully: ` + id)
						setIsError(false)
						return response
					} else if (response.statusText === "Unauthorized") {
						throw new Error("Unauthorized")
					} else {
						console.log(response.statusText)
						throw new Error("Something went wrong")
					}
				})
				.catch((error) => {
					setIsError(true)
					console.error("Error: ", error)
				})
				.finally(() => {
					setIsLoading(false)
				})
		},
		[getAccessTokenSilently]
	)

	useEffect(() => {
		return () => {
			setIsLoading(null)
			setIsError(null)
		}
	}, [])

	return { isLoading, isError, setIsError, removeItemFromGroup }
}
